import React, { useContext } from "react";
import { Button } from "components/ui/button";
import { IntlContext } from "context";
import { CheckCircle2, X } from "lucide-react";

type OfferPanelHeaderProps = {
    onClose: () => void;
};

const OfferPanelHeader: React.FC<OfferPanelHeaderProps> = ({ onClose }) => {
    const intl = useContext(IntlContext);

    return (
        <div className="border-b border-slate-100 px-8 py-8">
            <div className="flex items-start gap-4">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-emerald-500 text-white shadow-sm">
                    <CheckCircle2 className="h-6 w-6" strokeWidth={2.25} aria-hidden="true" />
                </div>
                <div className="min-w-0 flex-1">
                    <h2 className="text-3xl font-black leading-10 text-gray-900 text-wrap-balance">
                        {intl.formatMessage("booking.messages.offer.title")}
                    </h2>
                    <p className="mt-1 text-base text-slate-500">
                        {intl.formatMessage("booking.messages.offer.subtitle")}
                    </p>
                </div>
                <Button
                    type="button"
                    variant="ghost"
                    size="icon"
                    className="h-8 w-8 rounded-full"
                    aria-label={intl.formatMessage("booking.messages.offer.close")}
                    onClick={onClose}
                >
                    <X className="h-4 w-4 text-slate-400" aria-hidden="true" />
                </Button>
            </div>
        </div>
    );
};

export default OfferPanelHeader;
